export default __webpack_public_path__ + "static/media/bell.4f8da9e2.svg";